import { useDispatch, useSelector } from "react-redux";
import { Image } from "../image/image";
// import { levelNames } from "../../config/levelNames";
import { useId, useRef, useState } from "react";
import { CheckMarkIcon, EditIcon, LoadImageIcon } from "../../assets/icons";
import { setProfilePhoto, setUserName } from "../../features/userReducer";
import { Button } from "../button/button";
import { DEFAULT_ICON } from "../../config/constants";
import classNames from "classnames";
import UserAPI from "../../api/UserAPI";

import styles from "./editableUserInfo.module.css";


export const EditableUserInfo = () => {
    const { userId, profilePhotoUrl, name, userData } = useSelector((state) => state.user);
    const { level, totalExp, cafeId, kpiSchemeId } = userData;

    // const userLevel = level || 1;
    // const progress =
    //     (level >= levelNames.length) ? 0 :
    //         (levelNames[userLevel][1] - totalExp) / (levelNames[userLevel][1] - levelNames[userLevel - 1][1])

    const inputId = useId();
    const [userName, setUserNameValue] = useState(name);
    const [photoUrl, setPhotoUrl] = useState(profilePhotoUrl || DEFAULT_ICON);
    const [editing, setEditing] = useState(false);

    const dispatch = useDispatch();
    const textareaRef = useRef(null);

    const handleSave = async () => {
        if (userName.length <= 1 || userName.length >= 255 || !userId)
            return;

        try {
            await UserAPI.updateUserInfo(userId, {
                name: userName,
                cafeId,
                level,
                totalExp,
                kpiSchemeId,
            });
            dispatch(setUserName(userName));
        } catch (error) {
            console.error("Ошибка при сохранении имени:", error);
        }
    }

    const handleImageChange = async (e) => {
        const file = e.target.files[0];

        let fileUrl = DEFAULT_ICON;
        try {
            fileUrl = URL.createObjectURL(file);
            setPhotoUrl(fileUrl);
        } catch (error) {
            console.error("Ошибка при загрузке фото:", error);
        }

        handleSave();
        setEditing(false);

        if (file) {
            if (!!profilePhotoUrl) {
                try {
                    await UserAPI.deleteProfilePhoto();
                } catch (error) {
                    console.error("Ошибка при удалении фото:", error);
                }
            }

            try {
                const newPhotoUrl = await UserAPI.uploadProfilePhoto(file);
                dispatch(setProfilePhoto(newPhotoUrl));
                setPhotoUrl(newPhotoUrl);
                URL.revokeObjectURL(fileUrl);
            } catch (error) {
                console.error("Ошибка при загрузке фото:", error);
            }
        }
    }

    return (
        <header className={classNames(styles.header, { [styles.editing]: editing, [styles.error]: editing && (userName.length <= 1 || userName.length >= 255) })}>
            <div style={{ alignItems: "center", display: "flex", height: "100%", minWidth: "0px", overflow: "hidden" }}>
                <input
                    style={{ minWidth: "0" }}
                    className={styles.header_title}
                    value={userName}
                    onChange={(e) => setUserNameValue(e.target.value.replaceAll("\n", ""))}
                    disabled={!editing}
                    ref={textareaRef}
                />
            </div>

            <div className={styles.header_user_info}>
                {/* <div className={styles.user_level}>
                    <Text tag="div" view="caption" className={styles.user_level_title} >Уровень</Text>
                    <Text tag="div" view="heading" className={styles.user_level_name} >{userLevel ? levelNames[userLevel - 1][0] : "Загрузка..."}</Text>
                    <div className={classNames(styles.retractable)}>
                        <div style={{ minWidth: 0, overflow: "hidden" }}>
                            <div className={styles.user_level_progress}>
                                <div className={styles.user_level_progress_thumb}

                                    style={{
                                        width: `${10 + 90 * (1 - progress)}%`
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div> */}

                <label htmlFor={inputId} className={styles.editable_image} onClick={(e) => (!editing) && e.preventDefault()}>
                    <Image width="40px" height="40px" className={styles.header_user_image} objectFit="cover" src={photoUrl} />

                    <input
                        id={inputId}
                        type="file"
                        className={styles.image_input}
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                    <div className={styles.load_image_icon}>
                        <LoadImageIcon />
                    </div>
                </label>
            </div>

            <Button
                className={styles.edit_button}
                icon={editing ? <CheckMarkIcon /> : <EditIcon />}
                type={editing ? "primary" : "secondary"}
                disabled={editing && (userName.length <= 1 || userName.length >= 255)}
                onClick={() => {
                    if (editing) {
                        handleSave();
                    } else {
                        textareaRef.current?.focus();
                    }
                    setEditing((prev) => !prev);
                }}
            />
        </header>
    )
}
